import { FC, lazy } from 'react';

const PromocodesDefaultView = lazy(() => import('./default-view/PromocodesDefaultView'));

export const PromocodesPage: FC = () => <PromocodesDefaultView />;
